<template>
<layout-content>
  <template #toolbar>
    <section class="toolbar-btn">
      <el-button
        type="orange"
        icon="el-icon-plus"
        size="small"
        @click="onOpenEditor()"
      >新建{{editName}}</el-button>
    </section>
  </template>

  <template #body>
    <data-wrapper>
      <sidebar-content :title="siderTitle" sidebarWidth="230px" >
        <template #sidebar-body>
          <audit-rule-category-sidebar ref="rule-category" />
        </template>

        <template #sidebar-content-body>
          <el-table
            ref="table"
            :data="list"
            height="100%"
            border
            stripe
            highlight-current-row
            header-row-class-name="custom-table-header"
            class="custom-table no-inner-border"
            style="width: 100%"
            @selection-change="onSelectionChange"
            @row-click="onOpenEditor"
          >
            <el-table-column label="序号" width="50">
              <template slot-scope="{$index}">{{$index + 1}}</template>
            </el-table-column>

            <el-table-column prop="description" label="规则描述">
              <template slot-scope="{row}">
                <section v-html="row.description"></section>
              </template>
            </el-table-column>

            <el-table-column label="是否启用" align="center" width="80">
              <template slot-scope="{row}">
                <my-switch
                  v-model="row.status"
                  @click.native.stop
                  @change="onChangeStatus(row, ...arguments)"
                />
              </template>
            </el-table-column>

            <el-table-column label="操作" width="150" align="center">
              <template slot-scope="{row}">
                <div class="table-operator-wrapper">
              <span class="table-operator-btn delete-btn" @click.stop="onShowDeleteConfirmDialog(row)">
                <i class="el-icon-delete" aria-hidden="true"></i>
              </span>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </sidebar-content>
    </data-wrapper>
  </template>

  <template #editor>
    <editor
      ref="editor"
      :audit-rule-category="auditRuleCategory"
      :bit-map="bitMap"
      :audit-rule-factor-map="auditRuleFactorMap"
      @save="onAuditRuleSave"
      @close="onCancelHighlightTableRow"
    />
  </template>
</layout-content>
</template>

<script>
import AuditRuleCategorySidebar from './AuditRuleCategorySidebar'
import BaseListEditor from '../../../BaseListEditor'
import {AUDIT_RULE_CATEGORY_SELECT_CHANGED} from './EventKeys'
import Editor from './Editor'
import SidebarContent from '../../../../components/Layout/SidebarContent'
import DataWrapper from '../../../../components/Data/DataWrapper'

export default {
  name: 'SystemSettingsAutoAuditRule',
  routeInfo: {
    label: '机审规则',
    icon: 'fa fa-list-ul',
    curdInfo: {
      api: 'AutoAuditRule',
      id: 'id',
      name: 'name',
      editName: '机审规则'
    }
  },
  extends: BaseListEditor,
  components: {DataWrapper, SidebarContent, AuditRuleCategorySidebar, Editor},
  data () {
    return {
      auditRuleCategory: {},
      auditRuleFactors: [],
      titleCensus: '--'
    }
  },
  computed: {
    bitMap: () => new Array(24).fill(null).reduce((map, n, index) => {
      map[1 << index] = index
      return map
    }, {}),
    auditRuleFactorMap () {
      return this.auditRuleFactors.reduce((map, {auditRuleId, factorId}) => {
        let list = map[auditRuleId]

        if (!Array.isArray(list)) {
          list = map[auditRuleId] = []
        }

        list.push(factorId)
        return map
      }, {})
    },
    siderTitle () {
      return '机审规则类型' + '  ' + this.titleCensus
    }
  },
  methods: {
    onAuditRuleCategorySelectChanged (auditRuleCategory) {
      if (auditRuleCategory) {
        this.query.auditRuleTypeId = auditRuleCategory.id
        this.auditRuleCategory = auditRuleCategory
        this.getUsedFactors()
        this.getList()
      }
    },
    search () {
      this.clearSelectedList()
      this.getUsedFactors()
      this.getList()
    },
    getUsedFactors () {
      this.$api.AutoAuditRule.getUsedFactors(this.auditRuleCategory.id).then(auditRuleFactors => {
        this.auditRuleFactors = Object.freeze(auditRuleFactors)
      }).catch(console.error)
    },
    setList (list) {
      let {auditRuleCategory} = this
      let {description, field} = auditRuleCategory

      if (field) {
        let {bitMap} = this
        let {multi} = auditRuleCategory

        if (multi) {
          list.forEach(item => {
            let threshold = item.threshold
            let thresholds = []

            while (threshold > 0) {
              let bit = -threshold & threshold
              threshold ^= bit
              thresholds.push(bitMap[bit])
            }

            item.description = description.replace(new RegExp(`\\{\\{${field}\\}\\}`, 'ig'), `<span style="color:#409EFF;">${thresholds.join(', ')}</span>`)

            if (item.param) {
              let param = item.param.split('|')
              param.forEach((el, index) => {
                item.description = item.description.replace(new RegExp(`\\{\\{param\\[${index}\\]\\}\\}`, 'ig'), `<span style="color:#409EFF;">${param[index]}</span>`)
              })
            }
          })
        } else {
          list.forEach(item => {
            item.description = description.replace(new RegExp(`\\{\\{${field}\\}\\}`, 'ig'), `<span style="color:#409EFF;">${bitMap[item.threshold]}</span>`)

            if (item.param) {
              let param = item.param.split('|')
              param.forEach((el, index) => {
                item.description = item.description.replace(new RegExp(`\\{\\{param\\[${index}\\]\\}\\}`, 'ig'), `<span style="color:#409EFF;">${param[index]}</span>`)
              })
            }
          })
        }
      } else if (description.search('param') !== -1) {
        list.forEach(item => {
          item.description = description
          if (item.param) {
            let param = item.param.split('|')
            param.forEach((el, index) => {
              item.description = item.description.replace(new RegExp(`\\{\\{param\\[${index}\\]\\}\\}`, 'ig'), `<span style="color:#409EFF;">${param[index]}</span>`)
            })
          }
        })
      } else {
        list.forEach(item => {
          item.description = description
        })
      }

      this.list = list
    },
    onAuditRuleSave () {
      this.getUsedFactors()
      this.getList()
      this.$refs['rule-category'].getRuleCategories()
    },
    deleteSuccess () {
      this.search()
      this.$refs['rule-category'].getRuleCategories()
      this.$notify({
        title: '成功',
        message: '删除成功',
        type: 'success',
        position: 'bottom-right'
      })
    },
    getTitleCensus (data) {
      this.titleCensus = data
    }
  },
  created () {
    this.$eventBus.on(AUDIT_RULE_CATEGORY_SELECT_CHANGED, this.onAuditRuleCategorySelectChanged)
    this.$eventBus.on('getTitleCensus', this.getTitleCensus)
  },
  beforeDestroy () {
    this.$eventBus.off(AUDIT_RULE_CATEGORY_SELECT_CHANGED, this.onAuditRuleCategorySelectChanged)
    this.$eventBus.off('getTitleCensus', this.getTitleCensus)
  }
}
</script>

<style lang="scss" scoped>
.auto-audit-rule-wrapper {
  $SIDE-BAR-WIDTH: 230px;

  position: relative;
  width: 100%;
  height: 100%;
  padding-left: calc(230px + .8em);

  > .audit-rule-category-sidebar-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    width: 230px;
    height: 100%;
  }

  > .auto-audit-rule-list-editor {
    width: 100%;
    height: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/09System-Settings/04Config/05Auto-Audit-Rule/index.vue